/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Aurora-specific properties. Present only for Aurora clusters. 
*/
export class AwsRdsResourceAurora {
  /**
  * Role in an Aurora Global Database. - `primary` - This cluster is the primary/writer cluster - `secondary` - This cluster is a secondary/reader cluster Empty if not part of a Global Database. 
  */
  'globalDbRole'?: string;
  /**
  * For secondary clusters in a Global Database, the ARN of the primary cluster it replicates from. 
  */
  'replicationSourceArn'?: string;
  /**
  * The Global Database identifier that this cluster belongs to. Empty if not part of a Global Database. 
  */
  'globalClusterIdentifier'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "globalDbRole",
      "baseName": "globalDbRole",
      "type": "string",
      "format": ""
    },
    {
      "name": "replicationSourceArn",
      "baseName": "replicationSourceArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "globalClusterIdentifier",
      "baseName": "globalClusterIdentifier",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsRdsResourceAurora.attributeTypeMap;
  }

  public constructor() {
  }
}

